import PrivacyPolicy from "../components/Privacyandterms/Privacypolicy"





const Privacypage = () => {
  return (
    <div>

        <PrivacyPolicy/>

        

    </div>
  )
}

export default Privacypage